import { EnabledTool } from 'types/project';

export const addConfigurationRent = (spaceConfigurator: EnabledTool, complexName?: string) => {
  if (spaceConfigurator) {
    const spaceConfiguratorUrl = new URL(spaceConfigurator.url);
    if (complexName) {
      spaceConfiguratorUrl.searchParams.append('complex', complexName);
    }

    window.open(spaceConfiguratorUrl.href, '_blank');
  }
};
